import { render, staticRenderFns } from "./IconChevronsRight.vue?vue&type=template&id=69a388d2"
import script from "./IconChevronsRight.vue?vue&type=script&lang=ts"
export * from "./IconChevronsRight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports